import React from 'react';
import MainLayout from '@/components/layout/MainLayout';
import { SEOHead } from '@/components/seo/SEOHead';
import ListYourEventForm from '@/components/forms/ListYourEventForm';
import { Calendar, Users, MapPin, TrendingUp } from 'lucide-react';

export default function ListYourEventPage() {
  return (
    <MainLayout>
      <SEOHead
        title="List Your Event Free | Business Events Hub | Jigsaw Conferences"
        description="Submit your conference, training session, or business event to our free directory. Reach more attendees and we'll help with delegate accommodation."
        url="https://events.jigsawconferences.co.uk/events/list-your-event"
      />

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-50 to-orange-50 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-testid="list-event-title">
            List Your Event Free
          </h1>
          <p className="text-xl text-gray-600">
            Get your conference, training event, or business gathering discovered by thousands of potential attendees.
          </p>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-12 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
            <div className="flex items-start space-x-4">
              <TrendingUp className="w-8 h-8 text-orange-600 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-bold text-gray-900 mb-2">Increase Attendance</h3>
                <p className="text-gray-600 text-sm">
                  Get discovered by business professionals actively searching for events in your industry and location.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <Users className="w-8 h-8 text-orange-600 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-bold text-gray-900 mb-2">Free Accommodation Help</h3>
                <p className="text-gray-600 text-sm">
                  We'll help your attendees, sponsors, and speakers book group accommodation and meeting rooms at no cost.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <MapPin className="w-8 h-8 text-orange-600 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-bold text-gray-900 mb-2">SEO & Visibility</h3>
                <p className="text-gray-600 text-sm">
                  Your event gets its own dedicated page with full SEO optimization for better search engine rankings.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <Calendar className="w-8 h-8 text-orange-600 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-bold text-gray-900 mb-2">Always Free</h3>
                <p className="text-gray-600 text-sm">
                  No listing fees, no booking fees, no hidden charges. Just a free service to help your event succeed.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Form Section */}
      <section className="py-12 bg-gray-50">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Submit Your Event</h2>
            <ListYourEventForm />
          </div>
        </div>
      </section>

      {/* Trust Section */}
      <section className="py-12 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-gray-600 mb-4">
            Trusted by event organisers since 2003
          </p>
          <p className="text-sm text-gray-500">
            Our team will review your submission within 24 hours and publish your event to our directory.
          </p>
        </div>
      </section>
    </MainLayout>
  );
}